import inboxService from "./inboxService";

const inboxesService = [
    ...inboxService
]

export  { inboxesService as default, inboxService};